import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";

const ActionFormatter = ({ requestId, supervisorStatus }) => (
	<div className="navLinkClass align-items-center">
		<Link
			to={{
				pathname: `/OffsiteWorkHours/${requestId}`,
				state: {
					itemStatus: supervisorStatus,
				},
			}}
		>
			<button className="btnStyle" title="View Detail">
				<FontAwesomeIcon
					id="edit"
					className="hoverEffect"
					icon={faEye}
					style={{
						height: "20px",
						width: "20px",
					}}
				/>
			</button>
		</Link>
	</div>
);

export default ActionFormatter;
